import { StatModule } from "@/core/modules/stat/objects/StatModule";

import ExaminationCounterView from "./views/ExaminationCounterView.vue";

export const examinationCounter: StatModule = new StatModule("examination", "ExaminationCounter", "examination", ExaminationCounterView);
